import { gql } from '@apollo/client'

export const UPDATE_USER = gql`
    mutation booking_update_user($request: UpdateBookingUserRequest!) {
        booking_update_user(request: $request) {
            success
        }
    }
`
// first_name: String!
//   last_name: String!
//   email: String!
